import api from '../api'
export default {
	namespaced: true,
	state: {
		farmerList: [],
		farmerTotal: ''
	},
	mutations: {
		GET_FARMER_LIST( state, data = {} ) {
			state.farmerList = data.records
			state.farmerTotal = data.total
		}
	},
	actions: {
		GET_FARMER_LIST( { commit, dispatch },  config ) {
			console.log(config)
			return api.getFarmerList( config ).then(( res ) => {
				commit( 'GET_FARMER_LIST', res.payload )
				return res
			}).catch(( rej ) => {
				window.myVue.$message.error( rej.message )
			})
		},
		GET_FARMER_DETAIL ({ commit, dispatch }, config) {
			return api.farmerDetail(config).then((res) => {
				return res
			}).catch((rej) => {
				window.myVue.$message.error(rej.message)
			})
		},
		DELETE_FARMER ({ commit, dispatch }, params) {
			return api.deletefarmer({
				params: params
			}).then((res) => {
				return res
			}).catch((rej) => {
				window.myVue.$message.error(rej.message)
			})
		},
		ADD_FARMER ({ commit, dispatch }, config) {
			return api.addfarmer(config).then((res) => {
				return res
			}).catch((rej) => {
				window.myVue.$message.error(rej.message)
			})
		},
		UPDATE_FARMER ({ commit, dispatch }, config) {
			return api.updatefarmer(config).then((res) => {
				return res
			}).catch((rej) => {
				window.myVue.$message.error(rej.message)
			})
		}
	}
}


// WEBPACK FOOTER //
// ./src/views/farmerManage/store/index.js